import { Injectable, inject } from "@angular/core";
import { Database } from "@angular/fire/database";
import { Store } from "@ngrx/store";
import { firstValueFrom, forkJoin, Observable, of, throwError } from "rxjs";
import { catchError, map, take, tap } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { AcuerdoMrbService } from "../../../acuerdo-mrb/acuerdo-mrb.service";
import { AppState } from "../../../app.state";
import { iCatalogos, mCatalogos } from "../../../entrada/entrada.interface";
import { EntradaService } from "../../../entrada/entrada.service";
import { cargaCatalogos } from "../../../states/catalogos/actions";
import { UsuarioService } from "../../../usuario/usuario.service";
import { sortCatalogo } from "../../../utils";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class LoadCatalogosService {
  private entradaService = inject(EntradaService);
  private usuarioService = inject(UsuarioService);
  private acuerdoMrbService = inject(AcuerdoMrbService);
  public readonly store: Store<AppState> = inject(Store);

  constructor(private http: HttpClient) {}

  cargaCatalogos(): Observable<iCatalogos> {
    return forkJoin({
      catTema: this.entradaService.getTemas().pipe(take(1)),
      catTipo: this.entradaService.getCatalogo("tipo").pipe(take(1)),
      catTipoTemas: this.getCatalogo("tipo_tema").pipe(take(1)),
      catTipoDespacho: this.getCatalogo("TIPO_DESPACHO").pipe(take(1)),
      catModoEntrada: this.entradaService.getCatalogo("modo_entrada").pipe(take(1)),
      catPrioridad: this.entradaService.getCatalogo("prioridad").pipe(take(1)),
      catEmpresa: this.entradaService.getCatalogo("empresa").pipe(take(1)),
      catRemitente: this.entradaService.getCatalogo("remitente").pipe(take(1)),
      catEnvioAB: this.entradaService.getCatalogo("forma_envio").pipe(take(1)),
      catFormaEnvio: this.acuerdoMrbService.getCatalogo(this.acuerdoMrbService.cats.TIPO_FORMA_ENVIO).pipe(take(1)),
      catUsuarios: this.usuarioService.getUsuarios().pipe(take(1)),
      catEntregable: this.entradaService.getCatalogo("entregable").pipe(take(1)),
      catEstatus: this.entradaService.getCatalogo("estatus").pipe(take(1)),
      catCategorizacion: this.getCatalogo("categorizacion").pipe(take(1)),
      catCategoria: this.getCatalogo("CATEGORIA").pipe(take(1)),
    }).pipe(
      map((result) => {
        const {
          catTema,
          catTipo,
          catTipoTemas,
          catModoEntrada,
          catPrioridad,
          catEmpresa,
          catRemitente,
          catEnvioAB,
          catFormaEnvio,
          catUsuarios,
          catEntregable,
          catEstatus,
          catTipoDespacho,
          catCategorizacion,
          catCategoria,
        } = result;

        // Procesa los datos aquí
        const sortedCatEmpresa = sortCatalogo(catEmpresa, "descripcion");
        const sortedCatUsuarios = sortCatalogo(catUsuarios, "nombre");

        //DUPLICAMOS USUARIO SUPERVISOR EN ESPECIFICO
        let usuarioClone = catUsuarios.filter((item:any) => (item.id == environment.user_supervisor && item.rol == 2));
        if(usuarioClone.length == 1) {
          let usuarioCoordinador = structuredClone(usuarioClone[0]);
          usuarioCoordinador.rol = 3;
          sortedCatUsuarios.push(usuarioCoordinador);
        }

        // Aquí puedes transformar el resultado si es necesario
        return {
          catTema,
          catTipo,
          catTipoTemas,
          catModoEntrada,
          catPrioridad,
          catEmpresa: sortedCatEmpresa,
          catRemitente,
          catEnvioAB,
          catFormaEnvio,
          catUsuarios: sortedCatUsuarios,
          catEntregable,
          catEstatus,
          catTipoDespacho,
          catCategorizacion,
          catCategoria,
          isloading: true, // O cualquier otro flag que necesites
        };
      }),
      catchError((error) => {
        console.error("Error en cargaCatalogos:", error);
        return of(mCatalogos);
      })
    );
  }

  getCatalogo(cat: string): Observable<any[]> {
    return this.http.get<any>(`${environment.catalogos.getCatalogo}${cat}`).pipe(
      map((data) => {
        if (data.error) {
          return [];
        }

        const catalogMapping: { [key: string]: any[] | undefined } = {
          tipo_tema: data.tipoTema,
          TIPO_DESPACHO: data.tipoDespacho,
          categorizacion: data.tiposCategorizacion,
          CATEGORIA: data.categoria,
        };

        return catalogMapping[cat] || [];
      }),
      catchError(() => {
        return of([]);
      })
    );
  }
}
